import React from 'react';
import { GridSquareCard } from './GridSquareCard';
import type { UserKind } from '@/components/ui/UserTypeIcon';

export interface SpecialUserCardProps {
    displayName: string;
    username: string;
    avatarUrl?: string;
    price?: string | number;
    highestOffer?: string | number;
    highest_offer?: string | number;
    bg?: string;
    textColor?: string;
    grainOpacity?: number;
    scale?: number;
    compact?: boolean;
    userKind?: UserKind;
    isOffer?: boolean;
    itemType?: string;
    onClick?: () => void;
    onOffer?: () => void;
}

export const SpecialUserCard: React.FC<SpecialUserCardProps> = (props) => {
    return <GridSquareCard {...props} />;
};

export default SpecialUserCard;
